import {DateUtil} from "./utils"

const WEEK_ARR = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
export default {
	minutefmt: function (value, fmt) {
		if (value) {
			if (!fmt) {
				fmt = 'mm:ss'
			}
			var v = value - 0;
			var d = new Date(v);
			if (d.getTime()) {
				return DateUtil.formatDate(d, fmt)
			}
		}
		return '';
	},
	timefmt: function (value, fmt) {
		if (value) {
			if (!fmt) {
				fmt = 'HH:mm:ss'
			}
			var v = value - 0;
			var d = new Date(v);
			if (d.getTime()) {
				return DateUtil.formatDate(d, fmt)
			}
		}
		return '';
	},
	datefmt: function (value, fmt) {
		if (value) {
			if (!fmt) {
				fmt = 'yyyy-MM-dd'
			}
			var v = value - 0;
			var d = new Date(v);
			if (d.getTime()) {
				return DateUtil.formatDate(d, fmt)
			}
		}
		return '';
	},
	datefmt1: function (value, fmt) {
		if (value) {
			if (!fmt) {
				fmt = 'MM月dd日'
			}
			var v = value - 0;
			var d = new Date(v);
			if (d.getTime()) {
				return DateUtil.formatDate(d, fmt)
			}
		}
		return '';
	},
	datefmt2: function (value, fmt) {
		if (value) {
			if (!fmt) {
				fmt = 'yyyy年MM月dd日'
			}
			var v = value - 0;
			var d = new Date(v);
			if (d.getTime()) {
				return DateUtil.formatDate(d, fmt)
			}
		}
		return '';
	},
	datefmt3: function (value, fmt) {
		if (value) {
			if (!fmt) {
				fmt = 'yyyyMMdd'
			}
			var v = value - 0;
			var d = new Date(v);
			if (d.getTime()) {
				return DateUtil.formatDate(d, fmt)
			}
		}
		return '';
	},
	datefmt4: function (value) {
		if (value == null) {
			return;
		}
		var d = new Date(value.replace(/-/g, '/'));
		var year = d.getFullYear();
		var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : '' + (d.getMonth() + 1);
		var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate();
		return year + "年" + month + "月" + day + "日";
	},
	datetimefmt: function (value, fmt) {
		if (value) {
			if (!fmt) {
				fmt = 'yyyy-MM-dd HH:mm:ss'
			}
			var v = value - 0;
			var d = new Date(v);
			if (d.getTime()) {
				return DateUtil.formatDate(d, fmt)
			}
		}
		return '';
	},
	weekfmt: function (value) {
		if (value) {
			// var v = value - 0;
			var d = new Date(value);
			if (d.getTime()) {
				var day = d.getDay();
				return WEEK_ARR[day] || '';
			}
		}
		return '';
	},
	pricefmt: function (value) {
		if (value === null || value === '' || value === undefined || isNaN(value)) {
			return 0;
		}
		return value / 100;
	},
	textSub: function (value, maxlen) {
		if (value) {
			maxlen = maxlen || 20
			if (value.length <= maxlen) {
				return value
			} else {
				return value.substring(0, maxlen) + '...'
			}
		}
		return ''
	},
	dateSub: function (value) {
		return value.substring(0,10)
	},
	dateSub1: function (value,minlen,maxlen) {
		if(value == undefined){
			return
		}
		return value.substring(minlen,maxlen)
	},
	MoneyFormat(money){
		if (money && money != null && Number(money) > 0) {
			money = String(money);
			var left = money.split('.')[0], right = money.split('.')[1];
			right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00';
			var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
			return (Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right;
		} else if (money == 0) { // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
			return '0.00';
		} else {
			return '';
		}
	},
	money(value,sub){  //sub=0,1
		return value.split('.')[sub]
	},
}



// WEBPACK FOOTER //
// ./src/assets/js/DataFilter.js